var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomModal', {
    ref: "vueUploadErrorModal",
    attrs: {
      "customClass": "generic-modals v--modal new-modal new-upload-error molecule-modal-ugc-error",
      "height": "auto",
      "name": "ugcUploadImageErrorModal",
      "width": "500",
      "clickToClose": false,
      "modalTitle": _vm.translations.ugcEPFileUpload,
      "dialogDesc": true
    },
    on: {
      "closed": _vm.closeAction,
      "beforeOpen": _vm.beforeOpenModal
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "new-modal-wrapper customs-tools",
      "elementType": "section"
    }
  }, [_c('ModalHeader', {
    attrs: {
      "backDisabled": true,
      "closeDisabled": false,
      "headerImg": true,
      "includeBack": false
    },
    on: {
      "closeEvent": _vm.closeAction
    }
  }), _c('UgcImageError', {
    attrs: {
      "requirements": _vm.imageRequirements
    },
    on: {
      "click": _vm.onCTAAction
    }
  }), _c('ugc-image-upload', {
    attrs: {
      "input-id": "error-modal-input",
      "textLabel": _vm.translations.uploadErrorChooseImage,
      "disableButton": false
    },
    on: {
      "before-upload": _vm.onCTAAction
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }